<template lang="pug">
.v-video-card.video-card(v-if="card" :style="{'backgroundColor': card.background}")
	img.video-card__bg(v-if="card.image" :src="card.image.src" :alt="card.image.alt")
	.video-card__content
		.video-card__title(v-if="card.title" :style="{'color': card.color}") {{card.title}}
	a.video-card__link.cover-link(v-if="card.link" :href="card.link") {{card.title}}
	button.video-card__btn(v-if="card.video" type="button" @click="openModal = true")
		v-svg-icon.video-card__btn-icon(icon="play")
	teleport(to="body")
		v-modal(v-if="card.video && openModal" @close="() => this.openModal = null")
			v-video-box.video-card__view(:src="card.video.src" :type="card.video.type" :play="true")
</template>

<script>

export default {

	props: {

		card: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			openModal: null
		}
	}
}

</script>